import { tv } from "@/lib/tailwind-variants";

export const buttonVariants = tv({
  base: "inline-flex items-center justify-center rounded-sm border text-sm leading-tight ring-offset-white transition-colors focus-visible:border-info-500 focus-visible:ring-2 focus-visible:ring-info-500/50 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-300",
  variants: {
    variant: {
      primary:
        "border-transparent bg-primary text-white hover:bg-primary-600 [&]:hover:text-white",
      secondary:
        "border-primary bg-white text-primary hover:bg-primary-100 [&]:hover:text-primary",
      gray: "border-gray-300 bg-white text-gray-600 hover:bg-gray-50 [&]:hover:text-gray-600",
      red: "border-transparent bg-error text-white hover:bg-error-500/80 [&]:hover:text-white",
      white:
        "border-primary bg-white text-gray-600 hover:bg-gray-100 [&]:hover:text-gray-600",
      ghost:
        "border-transparent bg-transparent text-primary hover:bg-primary-50 [&]:hover:text-primary",
      link: "border-none text-primary underline-offset-4 hover:underline [&]:hover:text-primary",
    },
    size: {
      large: "h-13 px-8 py-4",
      medium: "h-8.5 px-4 py-2",
      small: "h-[26px] px-2 py-1",
      icon: "size-8.5",
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "large",
  },
});

export const pushButtonVariants = tv({
  base: "inline-flex items-center justify-center rounded-sm border text-sm leading-tight ring-offset-white transition-colors focus-visible:border-info-500 focus-visible:ring-2 focus-visible:ring-info-500/50 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-300",
  variants: {
    active: {
      true: "border-transparent bg-primary-600 text-white hover:bg-primary-600/80",
      false: "border-gray-300 bg-white text-primary hover:bg-primary-100",
    },
    size: {
      large: "h-13 px-8 py-4",
      medium: "h-8.5 px-4 py-2",
      small: "h-[26px] px-2 py-1",
    },
  },
  defaultVariants: {
    size: "large",
    active: false,
  },
});
